import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a7f54f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "toggle-switch",
  "data-ts": "toggleSwitch"
}
const _hoisted_2 = ["aria-label", "checked", "disabled", "aria-checked"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    label: {},
    labelRight: { type: Boolean },
    isChecked: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['toggle-switch__label', { 'toggle-switch__label--right': _ctx.labelRight }])
        }, _toDisplayString(_ctx.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "checkbox",
      "aria-label": _ctx.label,
      checked: _ctx.isChecked,
      disabled: _ctx.disabled,
      "aria-checked": _ctx.isChecked,
      class: "toggle-switch__input",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', ($event.target as HTMLInputElement).checked)))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", {
      role: "presentation",
      class: _normalizeClass(['toggle-switch__box', { 'toggle-switch__box--disabled': _ctx.disabled }])
    }, null, 2)
  ]))
}
}

})